import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from "@iconify/react";
import cn from 'classnames';

const CategorySection = ({ onChange = () => { } }) => {
  const { list } = useSelector(state => state.category);
  const { language } = useSelector((state) => state.app);

  const [selected, setSelected] = useState(false);

  useEffect(() => {
    onChange(selected)
  }, [selected])

  return (
    list &&
    <div className="grid grid-cols-4 gap-x-5 gap-y-8">
      {list.map((item, index) =>
        <div key={index} className="flex flex-col gap-1 justify-start h-full" onClick={() => setSelected(selected === item.id ? false : item.id)}>
          <div className="relative flex justify-center items-center rounded-2xl py-5 shadow">
            <div
              className={cn(
                'absolute inset-0 rounded-2xl',
                {
                  'opacity-20': selected !== item.id
                }
              )}
              style={{ backgroundColor: item.color }}
            />
            <span className="relative z-10" style={{ color: selected === item.id ? 'white' : item.color }}>
              <Icon
                icon={item.icon ? item.icon : 'lucide:circle-alert'}
                className="h-8 w-8"
              />
            </span>
          </div>
          <span className="text-[0.65rem] text-center leading-4 font-semibold">
            {item?.name[language]}
          </span>
        </div>
      )}
    </div>
  )
}

export default CategorySection;